import { render } from "./OrderCustormerInfo.vue?vue&type=template&id=5f8b67c3"
import script from "./OrderCustormerInfo.vue?vue&type=script&lang=js"
export * from "./OrderCustormerInfo.vue?vue&type=script&lang=js"

import "./OrderCustormerInfo.vue?vue&type=style&index=0&id=5f8b67c3&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__